/* eslint-disable */
/*
 * Slim v5.2.1 - Image Cropping Made Easy
 * Copyright (c) 2019 Rik Schennink - https://pqina.nl/slim
 */
// Necessary React Modules
import React from 'react';
import ReactDOM from 'react-dom';

// Slim (place slim CSS and module js file in same folder as this file)
import Slim from './slim/slim.module.js';
import './slim/slim.min.css';

// React Component
export default class extends React.Component {

  state = {
    removePhoto: false
  }

  componentDidMount() {
    var root = ReactDOM.findDOMNode(this);
    const defaults = {
      buttonEditTitle: 'Crop',
      buttonEditLabel: 'Crop',
      clip: this.props.clip,
      buttonClipTitle: 'Edit Clipping Mask',
      buttonClipLabel: 'Edit Clipping Mask',
      willClip: () => {
        if (this.props.onClipClick) {
          this.props.onClipClick()
        }
      },
      label: 'Loading image…',
      post: 'actions',
      uploadBase64: false,
      defaultInputName: this.props.name,
      didRemove: this.setRemoveHiddenField.bind(this),
    }

    const props = { ...defaults, ...this.props }

    if (props.initialImage) {
      var img = document.createElement('img');
      img.setAttribute('alt', '');
      img.src = props.initialImage;
      root.appendChild(img);
    }

    this.instance = Slim ? Slim.create(root, props) : null;
  }

  componentWillUnmount() {
    this.instance.destroy();
  }

  setRemoveHiddenField() {
    this.setState({
      removePhoto: true
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className={`slim ${this.props.className || null}`}>
          {this.props.canRemove ? (
            <input id={this.props.id} type="file" />
          ) : null}
          {this.props.children}
        </div>
        <input type="hidden" name="remove_photo" value={this.state.removePhoto ? 1 : 0} />
      </React.Fragment>
    )
  }
};
